import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { Rol } from '@eventos-cien/shared';
import { useAuth } from './AuthProvider';
import { Callout } from '../components/Callout';
import { Screen } from '../components/Screen';
import { CargaPagina } from '../components/Spinner';

interface Props {
  children: ReactNode;
  /** Si se indica, exige alguno de estos roles ademas de la sesion. */
  roles?: Rol[];
}

export function RutaProtegida({ children, roles }: Props) {
  const { cargando, user, tieneRol } = useAuth();
  const location = useLocation();

  if (cargando) return <CargaPagina />;

  if (!user) {
    return (
      <Navigate to="/login" replace state={{ from: location.pathname }} />
    );
  }

  if (roles && !tieneRol(...roles)) {
    return (
      <Screen centrado>
        <Callout tono="alerta">
          No tienes permiso para esta sección.
        </Callout>
      </Screen>
    );
  }

  return <>{children}</>;
}
